<template>
  <mobile v-if="gl.isMobile">
    <template #content><slot name="content"></slot></template>
  </mobile>
  <desktop v-else>
    <template #content><slot name="content"></slot></template>
  </desktop>
</template>

<script>
// store
import { useGl } from '@store/ts/gl';

// components
import Desktop from './desktop.vue';
import Mobile from './mobile.vue';

export default {
    name: 'rb-input',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        const gl = useGl();
    
        return {
            gl,
        };
    },
};
</script>
